import React from 'react';
import './BbcodeContent.css';

/** Escapa HTML para evitar XSS. */
const escapeHtml = (s) => {
  const str = String(s ?? '');
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

/**
 * Convierte BBCode a HTML de forma segura.
 * Soporta: [b], [i], [u], [s], [url=...], [url], [code], [quote], [list] y [*], saltos de línea.
 */
export const bbcodeToHtml = (bb) => {
  if (bb == null || typeof bb !== 'string') return '';
  let s = escapeHtml(bb);
  // [code]...[/code] (contenido ya escapado, mostramos en <pre><code>)
  s = s.replace(/\[code\]([\s\S]*?)\[\/code\]/gi, '<pre class="bbcode-code"><code>$1</code></pre>');
  // [quote]...[/quote]
  s = s.replace(/\[quote\]([\s\S]*?)\[\/quote\]/gi, '<blockquote class="bbcode-quote">$1</blockquote>');
  // [url=xxx]texto[/url] - solo permitir http/https (url/text ya vienen escapados de escapeHtml)
  s = s.replace(/\[url=(.*?)\]([\s\S]*?)\[\/url\]/gi, (_, url, text) => {
    const u = url.trim();
    if (!/^https?:\/\//i.test(u)) return text;
    return '<a href="' + u + '" target="_blank" rel="noopener noreferrer" class="bbcode-url">' + text + '</a>';
  });
  // [url]xxx[/url]
  s = s.replace(/\[url\]([\s\S]*?)\[\/url\]/gi, (_, url) => {
    const u = url.trim();
    if (!/^https?:\/\//i.test(u)) return u;
    return '<a href="' + u + '" target="_blank" rel="noopener noreferrer" class="bbcode-url">' + u + '</a>';
  });
  // [list]...[*/]...[/list] -> simplificado: [*] item
  s = s.replace(/\[list\]([\s\S]*?)\[\/list\]/gi, (_, inner) => {
    const items = inner.split(/\[\*\]/i).filter(Boolean).map((t) => t.trim());
    if (items.length === 0) return '';
    return '<ul class="bbcode-list">' + items.map((item) => '<li>' + item + '</li>').join('') + '</ul>';
  });
  // [b], [i], [u], [s]
  s = s.replace(/\[b\]([\s\S]*?)\[\/b\]/gi, '<strong>$1</strong>');
  s = s.replace(/\[i\]([\s\S]*?)\[\/i\]/gi, '<em>$1</em>');
  s = s.replace(/\[u\]([\s\S]*?)\[\/u\]/gi, '<u>$1</u>');
  s = s.replace(/\[s\]([\s\S]*?)\[\/s\]/gi, '<s>$1</s>');
  // Saltos de línea
  s = s.replace(/\n/g, '<br />');
  return s;
};

/**
 * Muestra contenido de texto con BBCode renderizado (negrita, cursiva, enlaces, código, etc.).
 */
const BbcodeContent = ({ content, className, tag: Tag = 'div' }) => {
  if (content == null || content === '') return null;
  const str = String(content).trim();
  if (!str) return null;
  const html = bbcodeToHtml(str);
  const cn = ['bbcode-content', className].filter(Boolean).join(' ');
  return <Tag className={cn} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default BbcodeContent;
